import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "maintenance-schedule-years" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("option", {
    disabled: "",
    value: "undefined"
}, "Select a Year", -1 /* HOISTED */);
const _hoisted_3 = ["value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.questionYearAnswer) = $event)),
            class: "maintenance-schedule-years__dropdown form-control",
            required: "",
            "aria-label": "Select A Vehicle Year",
            onChange: _cache[1] || (_cache[1] = ($event) => (_ctx.answered($event)))
        }, [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionYearAnswers, (year) => {
                return (_openBlock(), _createElementBlock("option", {
                    key: year,
                    class: "year",
                    value: year
                }, _toDisplayString(year), 9 /* TEXT, PROPS */, _hoisted_3));
            }), 128 /* KEYED_FRAGMENT */))
        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelSelect, _ctx.questionYearAnswer]
        ])
    ]));
}
